const tension = 0.5

function dista(arr, i, j) {
  return Math.sqrt(Math.pow(arr[2 * i] - arr[2 * j], 2) + Math.pow(arr[2 * i + 1] - arr[2 * j + 1], 2))
}

function va(arr, i, j) {
  return [arr[2 * j] - arr[2 * i], arr[2 * j + 1] - arr[2 * i + 1]]
}

function ctlpts(x1, y1, x2, y2, x3, y3, t) {
  var t = tension
  var v = va(arguments, 0, 2)
  var d01 = dista(arguments, 0, 1)
  var d12 = dista(arguments, 1, 2)
  var d012 = d01 + d12
  return [x2 - (v[0] * t * d01) / d012, y2 - (v[1] * t * d01) / d012, x2 + (v[0] * t * d12) / d012, y2 + (v[1] * t * d12) / d012]
}

function showPt(ctx, x, y, fillStyle) {
  // console.log("showPt", x, y);
  ctx.save()
  ctx.beginPath()
  if (fillStyle) {
    ctx.fillStyle = fillStyle
  }
  ctx.arc(x, y, 3, 0, 2 * Math.PI)
  ctx.fill()
  ctx.restore()
}

function drawLine(ctx, x1, y1, x2, y2, strokeStyle) {
  ctx.beginPath()
  ctx.moveTo(x1, y1)
  ctx.lineTo(x2, y2)
  if (strokeStyle) {
    ctx.save()
    ctx.strokeStyle = strokeStyle
    ctx.stroke()
    ctx.restore()
  } else {
    ctx.save()
    ctx.strokeStyle = 'pink'
    ctx.stroke()
    ctx.restore()
  }
}

function drawControlPoints(cps, ctx) {
  for (var i = 0; i < cps.length; i += 4) {
    showPt(ctx, cps[i], cps[i + 1], 'rgba(0,0,0,.25)')
    showPt(ctx, cps[i + 2], cps[i + 3], 'rgba(0,0,0,.25)')
    drawLine(ctx, cps[i], cps[i + 1], cps[i + 2], cps[i + 3], 'rgba(0,0,0,.25)')
  }
}

function drawPoints(pts, ctx) {
  for (var i = 0; i < pts.length; i += 2) {
    showPt(ctx, pts[i], pts[i + 1], 'black')
  }
}

function drawSplines(pts, ctx) {
  // clear()
  // console.log(pts);
  let cps = [] // There will be two control points for each "middle" point, 1 ... len-2e
  for (var i = 0; i < pts.length - 2; i += 1) {
    cps = cps.concat(ctlpts(pts[2 * i], pts[2 * i + 1], pts[2 * i + 2], pts[2 * i + 3], pts[2 * i + 4], pts[2 * i + 5]))
  }
  // drawControlPoints(cps, ctx)
  // drawPoints(pts, ctx)

  drawCurvedPath(cps, pts, ctx)
}

function drawCurvedPath(cps, pts, ctx) {
  // console.log("pts", pts, "cps", cps);
  var len = pts.length / 2 // number of points
  if (len < 2) return
  if (len == 2) {
    ctx.beginPath()
    ctx.moveTo(pts[0], pts[1])
    ctx.lineTo(pts[2], pts[3])
    ctx.stroke()
  } else {
    ctx.beginPath()
    ctx.moveTo(pts[0], pts[1])
    // from point 0 to point 1 is a quadratic
    ctx.quadraticCurveTo(cps[0], cps[1], pts[2], pts[3])
    // for all middle points, connect with bezier
    for (var i = 2; i < len - 1; i += 1) {
      // console.log("to", pts[2*i], pts[2*i+1]);
      ctx.bezierCurveTo(
        cps[(2 * (i - 1) - 1) * 2], // 2 -> 2
        cps[(2 * (i - 1) - 1) * 2 + 1], // 2 -> 3
        cps[2 * (i - 1) * 2], // 2 -> 4
        cps[2 * (i - 1) * 2 + 1], // 2 -> 5
        pts[i * 2], // 2 -> 4
        pts[i * 2 + 1] // 2 ->
      )
    }
    ctx.quadraticCurveTo(cps[(2 * (i - 1) - 1) * 2], cps[(2 * (i - 1) - 1) * 2 + 1], pts[i * 2], pts[i * 2 + 1])
    ctx.stroke()
  }
}

export default drawSplines